<div class="common-model-nav">
  <div>
    <div class="stk-nav">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" style="margin-bottom: 0px;padding-top: 1.5%;">
          <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">Group Maintenance</li>
          <div>
            <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'" class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon" 
              matTooltipPosition="left" title="Info" (click)="showInfo()">
            </button>
          </div>
        </ol>
      </nav>
    </div>

  </div>
</div>

<div class="lob-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header">
      </div>
      <div class="uitk-l-grid__row">
        <div class="uitk-l-grid__col--12">
          <div class="uitk_new_header">
            <div class="uitk-l-grid__col--12 stk-container-tabl-header">
              <div class="stk-header-action row">
                <div class="groupName col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
                  <span class="stk-c-header stk-container-header">
                    <span class="stk-title">
                      <span class="stk-header-title">Application Groups : {{Records.length}}</span>
                    </span>
                  </span>
                </div>
                <div class="col-md-8 col-sm-8 col-lg-8 col-xl-8 col-xs-8" style="display: flex; justify-content: flex-end;">
                  <ng-container>
                    <div class="table-search">
                      <mat-form-field appearance="outline">
                        <input matInput type="text" class="capability-search" placeholder="Search App Group"
                          (keyup)="searchDataSet($event)">
                        <img src="../../../../assets/images/searchicon.png" style="position: absolute;
                                                      right: 0px;
                                                      top: 10px;" />
                      </mat-form-field>
                    </div>
                  </ng-container>

                  <ng-container>
                    <button class="btn stk-action-add add-margin m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                       mat-mdc-raised-button  (click)="navigateToCreateGroup()">Create</button>
                  </ng-container>
                  <ng-container>
                    <button [disabled]="rowsToDelete.length ==0" style="right:0px; " mat-mdc-raised-button 
                    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs" (click)="deleteRecords()">Delete</button>
                  </ng-container>

                  
                  <div class="align-content-center">
                    <span class="stk-c-header stk-container-header" style="float: right; padding-right: 10.63%;max-width: 100%;min-width: 100%;cursor: pointer;">
                     
                      <span class="uitk-icon uitk-icon-download excelandinfo-Icon-font excel-top-padding" title="Click to download"
                      (click)="exportToExcel()"  style="cursor: pointer; pointer-events: auto; margin-left: 35.71%;"></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="uitk-c-card__content">
            <div class="stk-table-container">
              <ng-container>
                <app-group-maintenance-table [TABLE_CONFIG]="TABLE_CONFIG" [displayedColumns]="TABLE_COLUMNS" [oldDataSource]="Records"
                  [SORT_CONFIG]="sortConfig" [dataSource]="groups" [SCHEMA]="DATA_SCHEMA" [searchString]="searchString"
                  (paginationClickEvent)="tablePaginationEvent($event)" (rowsSelected)="deleteRowsSelected($event)"
                  [pageSize]="TABLE_CONFIG.pageSize" [pageIndex]="TABLE_CONFIG.pageIndex" (datachange)="updateGroup($event)">
                </app-group-maintenance-table>
              </ng-container>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
  <div class="hover_bkgr_fricc" (click)="hidepopup()">
    <span class="helper"></span>
    <div style="background: #fff;
      text-align: left;
      overflow-y: scroll;
      height: 500px;">
      <div class="popupCloseButton" (click)="hidepopup()">&times;</div>
      <p><strong>a. Create and Edit page for Admins: </strong></p>

      <p>· App Group Type can either be Platform or Custom, Visibility can either be Public or Private</p>

      <p>· If App Group Type is Platform, Visibility can be Public or Private</p>

      <p>· If App Group Type is Platform and Visibility is Public, it will not have a share Option </p>

      <p>· If App Group Type is Platform and Visibility is Private, it will have a share Option and limited to 9 users other
        than author.</p>

      <p>· If the Admin is not The App Group Owner, Share and transfer should not be available</p>

      <p>· If App Group Type is Custom, Visibility can only be Private and can be shared with 9 users other than author.</p>

      <p><strong>b. Create and Edit page for Non-Admin Users: </strong></p>

      <p>· App Group Type can only be Custom and Visibility Private.</p>

      <p>· Owner of the App Group will have Edit, Share, Transfer, View icons</p>

      <p>· User with who the App Group is shared with can only see View icon</p>

      <p>· Deleting a App Group will only be allowed to the App Group Owner</p>

      <p><strong>c. Select By option: </strong></p>

      <p>· When "selected by" value is "LOB" and if value in LOB and Sub-LOB is blank, then show all the applications
        under "Application" drop down.</p>

      <p>· When "selected by" value is "LOB" and if value in LOB and/or Sub-LOB is selected, then show only the filtered
        applications based on selected LOB/Sub-LOB.</p>

      <p>· When "selected by" value is "Tech Owner" and if value in Tech Owner is blank, then show all the applications
        under "Application" drop down.</p>

      <p>· When "selected by" value is "Tech Owner" and if value in Tech Owner is selected, then show only the filtered
        applications based on selected Tech Owner.</p>

      <p>· When "selected by" value is "SLO" and if value in SLO is blank, then show all the applications under
        "Application" drop down.</p>

      <p>· When "selected by" value is " SLO " and if value in SLO is selected, then show only the filtered applications
        based on selected SLO.</p>

      <p><strong>d. Export to Excel </strong></p>

      <p>· Should contain all the details that shown in View Details screen </p>

      <p><strong>e. All existing Groups are defaulted to App Group Type “Custom” and Visibility “Private”</strong></p>

      <p><strong> Edit application group</strong></p>

      <p><strong>f. Manage sharing tab will be visible on if the Visibility is “Private” </strong></p>

    </div>
  </div>
